import React from 'react'
import {  useSelector } from 'react-redux'
import { ISystemState } from 'model/system/systemReducer'
import { ViewDataSettings } from 'components/containers/dashboard/dataSettings/ViewComponent'




// Type
export type typeCashDesks = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
}



// Component
export const DataSettings: React.FC<typeCashDesks> = ({ variant, setSidebarOpen }) => {


    const position  = useSelector((state: { system: ISystemState }) => state.system.userInfo?.position)



    return (
        <ViewDataSettings
            variant={ variant }
            setSidebarOpen={ setSidebarOpen }
            position={position!}
        />

    )
}
